import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_CHECKLIST_CALENDAR_YEARS_SUCCESS action and sets the checklistCalendarYears in the store
 * @param {Object} [state] The checklistCalendarYears currently in the store, or the initial state of the checklistCalendarYears
 * @param {Object} action The action to be handled
 * @returns {Object} The checklistCalendarYears
 */
export default function checklistCalendarYearsReducer(
  state = initialState.checklistCalendarYears,
  action
) {
  if (
    action.type == actions.LOAD_CHECKLIST_CALENDAR_YEARS_SUCCESS &&
    Array.isArray(action.checklistCalendarYears)
  ) {
    return action.checklistCalendarYears;
  } else if (action.type == actions.LOAD_CHECKLIST_CALENDAR_YEARS_FAILURE) {
    return initialState.checklistCalendarYears;
  } else {
    return state;
  }
}
